import React from 'react';
import { Button } from 'reactstrap';

export default class ButtonAction extends React.PureComponent {
  getColor() {
    return this.props.color || 'primary';
  }

  getSize() {
    return this.props.size || 'md';
  }

  render() {
    const {action, icon, color, size, ...buttonProps} = this.props;
    return (<Button
      color={this.getColor()}
      onClick={this.props.action}
      size={this.getSize()}
      {...buttonProps}
    >
      <i className={`fa ${this.props.icon}`} aria-hidden/>
      {' '}
      {this.props.children}
    </Button>);
  }
}
